import React from "react";

/**
 * A bordered block with a titled header.
 *
 * The Apport tab puts colostrum, allaitement and aliments one after another, and
 * with only small grey captions between them they read as one long list. Giving
 * each its own card makes the boundary obvious at a glance on both form factors.
 */
export function SectionCard({ title, action, children, className = "" }) {
  return (
    <section
      className={
        "mb-4 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800 " +
        className
      }
    >
      {(title || action) && (
        <div className="flex min-h-[44px] items-center justify-between border-b border-stone-200 bg-stone-50 px-4 py-2 dark:border-slate-700 dark:bg-slate-900/40">
          <p className="text-xs font-semibold uppercase tracking-wider text-stone-500 dark:text-slate-400">
            {title}
          </p>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

/**
 * One labelled value inside a card. Label above value on a phone's narrow
 * column would waste height, so it stays a two-sided row there and becomes a
 * label column from `md` up.
 */
export function CardRow({ label, value, last }) {
  return (
    <div
      className={
        "flex min-h-[44px] items-center justify-between gap-4 px-4 md:min-h-0 md:py-2.5" +
        (last ? "" : " border-b border-stone-200/80 dark:border-slate-700/70")
      }
    >
      <span className="py-3 text-[15px] text-stone-500 md:w-1/3 md:shrink-0 md:py-0 md:text-xs md:font-semibold md:uppercase md:tracking-wider md:text-stone-400 dark:text-slate-400">
        {label}
      </span>
      <span className="text-right text-[15px] font-medium text-stone-900 md:flex-1 md:text-left dark:text-white">
        {value}
      </span>
    </div>
  );
}
